export const NotFound = () => {
    return <section className="not-found">
        404
    </section>
}